import { GenericActionsCell } from '@DesignSystem/generic-table-cells/ActionsCell/ActionsCell';
import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import './ServiceAccounts.scss';
import { LinkButton } from '@ds';
import { useLocation } from 'react-router';
import queryString from 'query-string';

export const SEARCH_PARAMS = {
  SERVICE_ACCOUNT_NAME: 'serviceAccountName'
};

const DateCell = ({ value }) => moment(value).format('DD MMM YYYY');

const NameCell = ({ value }) => (
  <span className="customization-table-name-cell">{value}</span>
);

const actionOptions = [
  {
    label: 'Delete',
    value: 'delete'
  }
];

const ActionsCell = ({ onDeleteClick }) => {
  return <GenericActionsCell options={actionOptions} onClick={onDeleteClick} />;
};

const ApiKeysCell = ({ row }) => {
  const location = useLocation();

  return (
    <LinkButton
      text="Manage API keys"
      to={{
        ...location,
        search: queryString.stringify({
          [SEARCH_PARAMS.SERVICE_ACCOUNT_NAME]: row.name
        })
      }}
    />
  );
};

ActionsCell.propTypes = {
  onDeleteClick: PropTypes.func.isRequired,
  onRegenerateClick: PropTypes.func.isRequired
};

const cellPropTypes = {
  value: PropTypes.string.isRequired
};

NameCell.propTypes = cellPropTypes;

const CustomizationTableCells = {
  ActionsCell,
  DateCell,
  NameCell,
  ApiKeysCell
};

export default CustomizationTableCells;
